import { render } from "./ExistingMagnet.vue?vue&type=template&id=c5138b2a&scoped=true&bindings={\"magnetIdentification\":\"props\",\"url\":\"data\",\"magnet\":\"data\",\"sight\":\"data\",\"imageSrc\":\"data\",\"iframeSrc\":\"data\",\"loading\":\"data\",\"errored\":\"data\",\"empty\":\"data\",\"updatable\":\"data\",\"updateableChanged\":\"data\",\"svIsOn\":\"data\",\"json\":\"data\",\"updateMagnet\":\"options\",\"updateMagnetAndCheckbox\":\"options\"}"
import script from "./ExistingMagnet.vue?vue&type=script&lang=js"
export * from "./ExistingMagnet.vue?vue&type=script&lang=js"

import "./ExistingMagnet.vue?vue&type=style&index=0&id=c5138b2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c5138b2a"

export default script